import React from "react";
import { logout } from "../../utils/authUtils";

export const Logout = () => {
  logout();
  return null;
};

export default Logout;
